export const SET_PIGMENT = 'SET_PIGMENT';
export const SET_INDUSTRY = 'SET_INDUSTRY';
export const SET_DOCUMENT_FAVORITE = 'SET_DOCUMENT_FAVORITE';
export const SAVE_DOCUMENT_FAVORITE = 'SAVE_DOCUMENT_FAVORITE';
export const DELETE_DOCUMENT_FAVORITE = 'DELETE_DOCUMENT_FAVORITE';
